module.exports = __webpack_public_path__ + "static/media/features-surface-ad3.cef49d3c.png";